<nx-card class="table-card-viewer">
  <page-list-view-header
    [newSupplier]="new()"
    [title]="'measuringDevice.headline'"
    >
  </page-list-view-header>
  <div class="aquila-table-custom">
    <aquila-table [rows]="models" [colDefinitions]="colDef" [actionConfig]="actionDef" [showAsList]="mobile"
      [elementsPerPage]="pageSize"
    [sort]="tableSort"></aquila-table>
  </div>
</nx-card>


<ng-template #myDetailTpl let-row="row" let-expanded="expanded">
  <div style="padding-left:35px;" class="w-100">
    @if (hasPermission) {
      @for (status of statuses; track status) {
        <button [disabled]="row.status==status" class="nx-margin-right-s" nxButton="tertiary small" type="button"
          (click)="changeStatus(row, status)"> {{ 'measuringDevice.' + status | caption }}
        </button>
      }
    }
  </div>
</ng-template>

<ng-template #colorTemplate let-value="value">
  <div [style]="'width:50px; height: 20px; background:'+value">
  </div>
</ng-template>
<ng-template #translateTemplate let-value="value">
  {{ 'measuringDevice.' + value | caption }}
</ng-template>

<ng-template #template>
  <div nxModalContent>
    <nx-card class="w-100 h-100">
      <nx-card-header>
        <h3 nxHeadline="subsection-small" class="nx-margin-bottom-s">
          {{ 'measuringDevice.dataExport' | caption }}
        </h3>
      </nx-card-header>
      <div nxRow="">
        <div nxCol="12,12,12,6">
          <nx-formfield label="{{'chart.filter.start' | caption}}">
            <input name="start" type="local-datetime" nxInput nxDatefield
              [datepicker]="startDatePicker"
              [max]="endDate"
              [(ngModel)]="startDate" required/>
              <nx-datepicker-toggle
                [for]="startDatePicker"
                nxFormfieldSuffix
              ></nx-datepicker-toggle>
              <nx-datepicker #startDatePicker></nx-datepicker>
            </nx-formfield>

          </div>

          <div nxCol="12,12,12,6">
            <nx-formfield label="{{'chart.filter.end' | caption}}">
              <input name="end" type="datetime" nxInput nxDatefield
                [datepicker]="endDatePicker"
                [max]="today"
                [min]="startDate"
                [(ngModel)]="endDate" required/>
                <nx-datepicker-toggle
                  [for]="endDatePicker"
                  nxFormfieldSuffix
                ></nx-datepicker-toggle>
                <nx-datepicker #endDatePicker></nx-datepicker>
              </nx-formfield>
            </div>

          </div>
        </nx-card>
      </div>
      <div nxModalActions>
        <button nxButton="small secondary"
          type="button" (click)="closeModal()">{{ 'general.cancel' | caption }}
        </button>
        @if (selected) {
          <button class="nx-margin-left-s" nxButton="small primary"
            type="button" (click)="export()">{{ 'general.export' | caption }}
          </button>
        }
      </div>
    </ng-template>
